<template>
    <form class="form" ref="form" @submit.prevent="submit">
        <slot :get="get" :set="set" :form="form" :submit="submit"></slot>
    </form>
</template>

<script>
import Form from '../forms/Form';
import Query from '../lib/Query';

export default {
    props: {
        url: {
            required: true,
        },
        method: {
            default: 'POST',
        },
        query: {
            default: () => {},
        },
        resetOnSuccess: {
            default: false,
        },
        autoCollect: {
            default: true,
        },
        value: {
            default: () => {},
        },
    },
    data() {
        return {
            form: new Form(this.value),
        };
    },
    methods: {
        get(attr) {
            return _.get(this.form, attr);
        },
        set(attr, value) {
            _.set(this.form, attr, value);
        },
        onSuccess(response) {
            if (this.resetOnSuccess) {
                this.$refs.form.reset();
            }

            this.$emit('success', response);
        },
        submit() {
            const self = this;
            let data = null;
            if (this.autoCollect) {
                data = Object.fromEntries(new FormData(this.$refs.form));
            }
            this.$messenger.loading();
            return this.form
                .sendForm(this.method, new Query(this.query).url(this.url), data)
                .then((response) => {
                    self.onSuccess(response);
                })
                .finally(() => {
                    self.$messenger.loaded();
                });
        },
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.form = new Form(newVal);
                }
            },
        },
    },
};
</script>
